import { getRequest, postRequest } from "src/utils";

export const getUserReq = () => getRequest(`${process.env.REACT_APP_API_URL}/auth/user`);

export const postLoginReq = (email: string, password: string) =>
	postRequest(`${process.env.REACT_APP_API_URL}/auth/login`, { email, password });
